import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import palceholderimage from "../../../assets/images/palceholderimage.webp";
import NeverWorn from "../../../assets/images/HomePage/never_worn.webp";
import NewIn from "../../../assets/images/HomePage/new_in.webp";
import PriceDrops from "../../../assets/images/HomePage/price_drops.webp";
import Vintage from "../../../assets/images/HomePage/vintage_2.webp";
import { useDispatch } from "react-redux";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  SetBottomSizeFilter,
  resetLoadingNumber,
  getAllProductOnline,
} from "../../../features/Products/ProductSlice";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Banner() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageLoaded, setImageLoaded] = useState(false);

  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }

  return (
    <>
      <div
        className={`row d-md-flex d-none  ${
          i18n.language == "en" ? "ms-0 me-0 " : `me-0 ms-0`
        }`}
        id="style-2"
        style={{ width: "100%", height: "3vw", minHeight: "40px" }}
      >
        <div
          className="col-12 d-flex p-lg-2  justify-content-center align-items-center mx-0 px-lg-3 px-0 "
          id="style-2"
        >
          <div
            className="d-md-flex d-none justify-content-center align-items-center banner"
            style={{ width: "100%", height: "3vw", minHeight: "40px" }}
          >
            <div className="text-start pt-md-0 pt-2 px-3 pb-1">
              <p
                className="mb-0"
                style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
              >
                {i18n.language === "ar" ? (
                  <>
                    وفر ١٠٠ درهم على أول طلب لك باستخدام الرمز{" "}
                    <strong>WELCOME100</strong>
                  </>
                ) : (
                  <>
                    Save 100 AED on your first order with code{" "}
                    <strong>WELCOME100</strong>
                  </>
                )}
              </p>
            </div>
          </div>
          <div
            className="d-md-none d-flex justify-content-center align-items-center banner"
            style={{ width: "100%", height: "5vw", minHeight: "80px" }}
          >
            <div className="text-start pt-md-0 pt-2  px-3">
              <p className="mb-0">
                <p
                  className="mb-0"
                  style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
                >
                  {i18n.language === "ar" ? (
                    <>
                      وفر ١٠٠ درهم على أول طلب لك باستخدام الرمز{" "}
                      <strong>WELCOME100</strong>
                    </>
                  ) : (
                    <>
                      Save 100 AED on your first order with code{" "}
                      <strong>WELCOME100</strong>
                    </>
                  )}
                </p>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`row d-md-none d-flex  ${
          i18n.language == "en" ? "ms-0 me-0 " : `me-0 ms-0`
        }`}
        id="style-2"
        style={{ width: "100%", height: "5vw", minHeight: "80px" }}
      >
        <div
          className="col-12 d-flex p-lg-2  justify-content-center align-items-center mx-0 px-lg-3 px-0 "
          id="style-2"
        >
          <div
            className="d-md-flex d-none justify-content-center align-items-center banner"
            style={{ width: "100%", height: "3vw", minHeight: "40px" }}
          >
            <div className="text-start pt-md-0 pt-2 px-3 pb-1">
              <p className="mb-0">
                {i18n.language === "ar" ? (
                  <>
                    وفر ١٠٠ درهم على أول طلب لك باستخدام الرمز{" "}
                    <strong>WELCOME100</strong>
                  </>
                ) : (
                  <>
                    Save 100 AED on your first order with code{" "}
                    <strong>WELCOME100</strong>
                  </>
                )}
              </p>
            </div>
          </div>
          <div
            className="d-md-none d-flex justify-content-center align-items-center banner"
            style={{ width: "100%", height: "5vw", minHeight: "80px" }}
          >
            <div className="text-start pt-md-0 pt-2  px-3">
              <p className="mb-0">
                {i18n.language === "ar" ? (
                  <>
                    وفر ١٠٠ درهم على أول طلب لك باستخدام الرمز{" "}
                    <strong>WELCOME100</strong>
                  </>
                ) : (
                  <>
                    Save 100 AED on your first order with code{" "}
                    <strong>WELCOME100</strong>
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      <br></br>
    </>
  );
}

export default Banner;
